import { memo } from 'react'

export default memo(function EditIcon(props: any) {
  return (
    <svg
      width={props.size || 32}
      height={props.size || 32}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36 25.3H12C11.3 25.3 10.8 24.7 10.8 24.1C10.8 23.5 11.4 22.9 12 22.9H36C36.7 22.9 37.2 23.5 37.2 24.1C37.2 24.7 36.7 25.3 36 25.3Z"
        fill={props.color || '#888'}
      ></path>
    </svg>
  )
})
